var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShop = function SvgShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.4444H5.33333V9.66667H8M16 9.66667V8.27778L15.1111 4.8H0.888889L0 8.27778V9.66667H0.888889V14.2222H9.77778V9.66667H13.3333V14.2222H14.2222V9.66667M15.1111 2.02222H0.888889V3.41111H15.1111V2.02222Z",
    fill: "currentColor"
  })));
};
export default SvgShop;